import React from 'react';
import { Link } from 'react-router-dom';

const CATEGORY_COLORS = {
  'Nyheter': '#3B6FD4',
  'Veioppdateringer': '#2A9D8F',
  'Tips & Råd': '#E9C46A',
  'Teknologi': '#9B5DE5',
  'Sikkerhet': '#E76F51'
};

const ArticleCard = ({ post, index }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr)?.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const categoryColor = CATEGORY_COLORS?.[post?.category] || '#3B6FD4';
  const rotation = index % 3 === 0 ? '-0.4deg' : index % 3 === 1 ? '0.3deg' : '-0.2deg';

  return (
    <Link
      to={`/individual-article-detail-view?slug=${post?.slug}`}
      style={{ textDecoration: 'none', display: 'block' }}
    >
      <article
        style={{
          background: '#0D1520',
          border: '1px solid rgba(255,255,255,0.07)',
          overflow: 'hidden',
          transform: `rotate(${rotation})`,
          transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
          cursor: 'pointer',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'rotate(0deg) translateY(-6px)';
          e.currentTarget.style.boxShadow = `0 24px 48px rgba(0,0,0,0.4), 0 0 0 1px ${categoryColor}40`;
          e.currentTarget.style.borderColor = `${categoryColor}40`;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = `rotate(${rotation})`;
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
        }}
      >
        {/* Image */}
        <div style={{ position: 'relative', height: '200px', overflow: 'hidden', flexShrink: 0 }}>
          <img
            src={post?.hero_image || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=600&h=300&fit=crop'}
            alt={post?.hero_image_alt || post?.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
          />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(13,21,32,0.8) 0%, transparent 60%)' }} />
          {/* Category tag */}
          <div
            style={{
              position: 'absolute',
              bottom: '12px',
              left: '12px',
              background: categoryColor,
              padding: '3px 10px',
              fontFamily: 'Syne, sans-serif',
              fontSize: '0.6rem',
              fontWeight: 700,
              color: '#EEF0F2',
              letterSpacing: '0.15em',
              textTransform: 'uppercase'
            }}
          >
            {post?.category}
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flex: 1 }}>
          {/* Date */}
          <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.7rem', color: 'rgba(238,240,242,0.4)', margin: '0 0 10px', letterSpacing: '0.05em' }}>
            {formatDate(post?.published_at)}
          </p>

          {/* Title */}
          <h3
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: '1rem',
              fontWeight: 800,
              color: '#EEF0F2',
              margin: '0 0 10px',
              lineHeight: 1.3,
              letterSpacing: '-0.01em',
              flex: 0
            }}
          >
            {post?.title}
          </h3>

          {/* Excerpt */}
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '0.85rem',
              color: 'rgba(238,240,242,0.6)',
              lineHeight: 1.65,
              margin: '0 0 16px',
              flex: 1,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {post?.excerpt}
          </p>

          {/* Author */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: 'auto', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            {post?.author_avatar && (
              <img
                src={post?.author_avatar}
                alt={`Portrett av ${post?.author_name}`}
                style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', border: `1px solid ${categoryColor}60` }}
              />
            )}
            <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', color: 'rgba(238,240,242,0.5)', fontWeight: 500 }}>{post?.author_name}</span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ArticleCard;
